import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';

const isBloomReachAudience = (enableBloomReach = false, isNative = false) => {
    if (!enableBloomReach || isNative) return false;

    const BRCookieValue = Cookies.load('BRtest', true);

    return !!BRCookieValue;
};

export default isBloomReachAudience;
